import { ChevronRight, ErrorOutlineRounded } from '@mui/icons-material'
import { InformationCard } from 'feature/informationCard'
import { useGetServiceCenterInformationQuery } from 'feature/serviceCenters/redux/service.api'
import { Coordinates } from 'feature/serviceCenters/types'
import { useEffect } from 'react'
import { ScrollRestoration, useNavigate } from 'react-router-dom'
import { Loading } from 'router/Loading'
import { useActions } from 'store/hooks'
import { Button } from 'ui'

import { ServiceCenterHeader } from '../ServiceCenterHeader'
import { ServiceCenterInformation } from '../ServiceCenterInformation/ServiceCenterInformation'

import style from './ServiceCenter.module.scss'

type TServiceCenter = {
  requestBody: {
    coordinates?: Coordinates | undefined
    id?: string | undefined
  }
  id: string | undefined
}

// детальная страница СЦ

export const ServiceCenter = ({ requestBody, id }: TServiceCenter) => {
  const navigate = useNavigate()
  const { data: service, isLoading: isServiceLoading } =
    useGetServiceCenterInformationQuery(requestBody)
  const { setStaticMarkCoords, setGeolocationMarkCoords, setCenter } =
    useActions()

  useEffect(() => {
    if (service) {
      setGeolocationMarkCoords(null)
      setStaticMarkCoords([
        Number(service.coordinatesLatitude),
        Number(service.coordinatesLongitude),
      ])
      setCenter([
        Number(service.coordinatesLatitude),
        Number(service.coordinatesLongitude),
      ])
    }
  }, [service])

  const handleBackClick = () => {
    navigate('/servicecenters', {
      state: { isServicePage: true },
    })
  }

  return (
    <section className={style.serviceCenter}>
      <ScrollRestoration />
      <Button
        variant='text'
        onClick={handleBackClick}
        className={style.backButton}
        startIcon={<ChevronRight color='primary' className='rotate180' />}
        data-testid='sc-detail-back-btn'
      >
        Назад
      </Button>

      <ServiceCenterHeader
        handleClick={handleBackClick}
        className={style.serviceHeader}
      />

      {service && !isServiceLoading && (
        <div className={style.ServiceCenterInformation}>
          <ServiceCenterInformation id={id} service={service} />
        </div>
      )}

      {!service && !isServiceLoading && (
        <InformationCard
          title='ошибка 404'
          subtitle='Страница не найдена'
          Icon={<ErrorOutlineRounded fontSize='large' color='primary' />}
          link='/'
          linkText='На главную'
        />
      )}
      {isServiceLoading && <Loading />}
    </section>
  )
}
